<app-input-header *ngIf="outsideLabel && labelValue" [labelKey]="labelValue" [required]="required"></app-input-header>
<mat-form-field
  *ngIf="!hours"
  appearance="outline"
  class="full-width background-white"
  [ngClass]="{ 'input-error': ngControl.control?.touched && ngControl.control?.errors, 'offers': colors === ColorSchemes.OFFERS }"
>
  <mat-label *ngIf="!outsideLabel && labelValue">{{ labelValue | locLabel }}</mat-label>
  <input
    matInput
    [disabled]="disabled"
    [placeholder]="placeholderKey | locLabel"
    [matDatepicker]="datePicker"
    [ngModel]="value"
    [min]="min"
    [max]="max"
    [matDatepickerFilter]="filterDaysFunc"
    (blur)="onTouch()"
    (dateChange)="value = $event.value"
    id="date"
  />
  <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
  <mat-datepicker #datePicker [ngClass]="{ 'offers': colors === ColorSchemes.OFFERS }" [startAt]="calendarStartAt"></mat-datepicker>
</mat-form-field>
<!-- HACK mat-form-field and mat-label repeated, because ng-container mess display because of reasons -->
<!-- TODO: input base class -->
<mat-form-field
  *ngIf="hours"
  appearance="outline"
  class="full-width background-white"
  [ngClass]="{ 'input-error': ngControl.control?.touched && ngControl.control?.errors }"
>
  <mat-label *ngIf="!outsideLabel && labelValue">{{ labelValue | locLabel }}</mat-label>
  <input
    matInput
    [disabled]="disabled"
    [placeholder]="placeholderKey | locLabel"
    [ngxMatDatetimePicker]="dateTimePicker"
    [ngModel]="value"
    [min]="min"
    [max]="max"
    [ngxMatDatetimePickerFilter]="filterDaysFunc"
    (blur)="onTouch()"
    (dateChange)="value = $event.value"
    id="hours"
  />
  <mat-datepicker-toggle matSuffix [for]="$any(dateTimePicker)"></mat-datepicker-toggle>
  <ngx-mat-datetime-picker
    #dateTimePicker
    [showSeconds]="false"
    [startAt]="calendarStartAt"
  ></ngx-mat-datetime-picker>
</mat-form-field>
<app-input-footer *ngIf="footer" [control]="ngControl?.control"></app-input-footer>
